import type { TextStyle } from 'react-native'

import type { FunkitTheme } from './toRestyleTheme'
import type { FunkitFontWeight } from './tokens'

/**
 * A theme's text style as a flat array, for the nodes that cannot afford
 * {@link Text}.
 *
 * Restyle resolves its style props and reads the theme per node, per render,
 * which a list of 245 rows or a strip of 27 letters redraws too often to pay
 * for. Those draw plain `Text` over this instead — one place where the order
 * lives, so a fast path cannot layer them differently from the rest.
 */
export function flatTextStyle(
  theme: FunkitTheme,
  options: { weight?: FunkitFontWeight } = {},
): TextStyle[] {
  const variant = theme.textVariants?.defaults as TextStyle | undefined
  const weight = options.weight
    ? (theme.textWeights?.[options.weight] as TextStyle | undefined)
    : undefined
  const color = theme.content?.elements?.primary
  return [
    ...(variant ? [variant] : []),
    ...(weight ? [weight] : []),
    ...(color ? [{ color }] : []),
  ]
}
